import { render, staticRenderFns } from "./LeadershipCoaching.vue?vue&type=template&id=5b40a4e6&scoped=true"
import script from "./LeadershipCoaching.vue?vue&type=script&lang=js"
export * from "./LeadershipCoaching.vue?vue&type=script&lang=js"
import style0 from "./LeadershipCoaching.vue?vue&type=style&index=0&id=5b40a4e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b40a4e6",
  null
  
)

export default component.exports